export var UserType;
(function (UserType) {
    UserType["Customer"] = "customer";
    UserType["Team"] = "team";
    UserType["M2M"] = "m2m";
})(UserType || (UserType = {}));
//# sourceMappingURL=UserType.js.map